import axios from 'axios';

export default async function (nameModule:string, action:string, restMethod:string, params = {}) {
    var response = {}
    //@ts-ignore
    if(typeof window.BX != 'undefined' && nameModule != 'evraz:lk.api.serviceforbpm'){
        //@ts-ignore
        response = await window.BX.ajax.runAction(nameModule + '.' + action, params);
    }
    else{

        const localApi = async(queryParams:any, bxModuleName:string, bxActionName:string,restMethod:string)=>{
            const bitrixBackendUrl = "https://evrazsteelbox.ru/bitrix/services/main/ajax.php?action="+bxModuleName + '.' + bxActionName;
            let data
            if (queryParams.data){
                 data = jsonToUrlEncoded(queryParams.data);
            }
            let axiosConfig = {}
            if (restMethod == 'post' && bxModuleName.includes('site')) {
                axiosConfig = {
                method: restMethod,
                data: data,
                headers: {'Content-type':'application/x-www-form-urlencoded'} 
                }
            } else if (restMethod == 'post' && bxModuleName.includes('bpm')) {
                axiosConfig = {
                    method: restMethod,
                    data: JSON.stringify(params),
                    headers: {'Content-type':'application/json'} 
                    }
            } else {
            axiosConfig = {
                method: restMethod,
                params:queryParams
            }
        }
            const responseAxios =  await axios(bitrixBackendUrl,axiosConfig)
            
            return responseAxios.data
        }

        function jsonToUrlEncoded(json: any, prefix=''):any {
            const str = [];
            for (let p in json) {
                if (json.hasOwnProperty(p)) {
                    const k = prefix ? `${prefix}[${encodeURIComponent(p)}]` : encodeURIComponent(p);
                    const v = json[p];
                    str.push(
                        (typeof v === "object" && v !== null)
                            ? jsonToUrlEncoded(v, k)
                            : `${k}=${encodeURIComponent(v)}`
                    );
                }
            }
            return str.join("&");
        }

        response = await localApi(params, nameModule,action, restMethod)
    }
 
    return response;
    
}
